module.exports = __webpack_public_path__ + "assets/time-up.e87662e0.svg";